module.exports = __webpack_public_path__ + "img/ic_search.f0d5f119.png";